// extracted by mini-css-extract-plugin
export default {"scoreBlock":"EFE3ZsXykNEPdPVHVBfX","scoreBlockWithRequestedLevel":"Yz0RgwJRLdQUdXxjBAHL","scoreLevel":"sqOPSTdtmpueoYg10WyZ","scoreBar":"zHYXdOTEM8QGwcOTm7HL"};